/// <amd-module name="Wit/Settings/BoardsExternalIntegration/utils/HistoryUtil" />
import { IVssPageContext } from "VSS/Platform/Context";
import { ILegacyPlatformService } from "VSS/Legacy/Legacy";
import { IVssHistoryService, StateMergeOptions } from "VSS/Platform/History";
import { GitHubConnectionConstants } from "Wit/Settings/BoardsExternalIntegration/constants/Constants";

/**
 * Removes OAuth redirect params from history state.
 */
export function removeRedirectParamsFromHistoryState(pageContext: IVssPageContext): void {
    const historyService = pageContext.getService<IVssHistoryService>("IVssHistoryService");
    const currentState = historyService.getState();

    if (_removeRedirectParamsFromState(currentState)) {
        const url: string = historyService.generateUrl(
            {
                ...currentState
            },
            StateMergeOptions.none
        );

        // we should hide the redirect url by replacing it; otherwise we end up with
        // stale key values in url
        historyService.replaceState(undefined, url);
    }
}

/**
 * Removes OAuth redirect params from legacy history state.
 */
export async function removeRedirectParamsFromLegacyHistoryState(pageContext: IVssPageContext): Promise<void> {
    const legacyService = pageContext.getService<ILegacyPlatformService>("ILegacyPlatformService");
    const [module] = await legacyService.requireModules(["VSS/Navigation/NavigationHistoryService"]);
    const legacyHistoryService = module.getNavigationHistoryService();
    const currentState: { [key: string]: string } = legacyHistoryService.getState();

    if (_removeRedirectParamsFromState(currentState)) {
        const url: string = legacyHistoryService.generateUrl(
            {
                ...currentState
            },
            StateMergeOptions.none
        );

        // we should hide the redirect url by replacing it; otherwise we end up with
        // stale key values in url
        legacyHistoryService.replaceState(undefined, url);
    }
}

function _removeRedirectParamsFromState(currentState: { [key: string]: string }): boolean {
    const redirectedBack = !!GitHubConnectionConstants.QueryParametersToRemove.some(p => !!currentState[p]);
    if (redirectedBack) {
        for (const property of GitHubConnectionConstants.QueryParametersToRemove) {
            delete currentState[property];
        }

        return true;
    }

    return false;
}
